import { MapTo } from '@adobe/aem-react-editable-components';
import Header from './Header';
import { WithEmptyPlaceholder } from '../../../../lib/hoc/WithEmptyPlaceholder';
import { HeaderProps } from './Header.types';

const RESOURCE_TYPE = 'learning-academy/components/custom/header';

const HeaderEmptyFn = (props: HeaderProps) => !props || Object.values(props).some(prop => prop === undefined);

const EditConfig = {
  emptyLabel: 'Header: Please configure component properties.',
  isEmpty: HeaderEmptyFn,
};

export default MapTo<HeaderProps>(RESOURCE_TYPE)(...WithEmptyPlaceholder(Header, EditConfig));
